import { message } from "antd";
import type { ContentTopic } from "api/config/chalice-types";
import { genericError } from "fixtures/globalConstants";
import { Dispatch, SetStateAction } from "react";
import { AppDispatch } from "store";
import { updateBusinessDetails } from "store/business/businessActions";

// --- Internal Helper Function --- //
export const saveTopics = async (
  newTopics: ContentTopic[],
  originalTopics: ContentTopic[],
  setDisplayTopics: Dispatch<SetStateAction<ContentTopic[]>>,
  dispatch: AppDispatch,
  currentBusinessId: string | undefined
) => {
  if (!currentBusinessId) {
    message.error("Business ID not found, cannot save topics.");
    setDisplayTopics(originalTopics); // Revert optimistic update
    return Promise.reject(new Error("Business ID not found"));
  }

  setDisplayTopics(newTopics); // Optimistic update

  try {
    await dispatch(
      updateBusinessDetails({ topics: newTopics } as any)
    ).unwrap();
    return Promise.resolve();
  } catch (error) {
    setDisplayTopics(originalTopics); // Revert on error
    genericError(error);
    return Promise.reject(error);
  }
};
// --- End Helper --- //
